export default "__VITE_ASSET__DbHyIaSE__"